export const getRoundPercentage = (src: number, digit: number): number => {
  const calcConstant = 10 ** digit;
  return Math.round(src * calcConstant) / calcConstant;
};
